export const MODAL_BODY_STYLES: React.CSSProperties = {
  maxHeight: '92vh',
  overflowY: 'auto',
};
